import React, { useEffect, useState } from "react";
import FeatherIcon from "feather-icons-react";
import { useSelector } from "react-redux";
import loadable from "@loadable/component";
import { useNavigate, useSearchParams } from "react-router-dom";

import AvatarCanvas from "./elements/AvatarCanvas";
import balanceIcon from "../../assets/images/ic_balance_outline.png";

const Loader = loadable(() => import("../../components/UI/Loader"));
const ProfileInfoForm = loadable(() => import("./elements/ProfileInfoForm"));
const PlayedGamesList = loadable(() => import("./elements/PlayedGamesList"));

const Settings = () => {
  const [searchParams] = useSearchParams();
  // Played Games holds offline downloads; open it directly with ?tab=played, and when offline.
  const [activeTab, setActiveTab] = useState(
    searchParams.get("tab") === "played" || !navigator.onLine ? "played" : "account"
  );
  const [selectedAvatar, setSelectedAvatar] = useState("");
  const AuthState = useSelector((state) => state.Auth);
  const SettingState = useSelector((state) => state.Settings);
  const { user, loginDetails } = AuthState;

  const navigate = useNavigate();

  useEffect(() => {}, [activeTab, user, loginDetails]);

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/");
    }
  }, [navigate]);

  return (
    <div className="py-5">
      {SettingState.loading && <Loader isTranserent={true} />}

      <div className="contentWrapper mx-2">
        <div className="innerSetting text-[#fff] text-center max-w-[550px] mx-auto my-5 mx-auto">
          <AvatarCanvas
            key={""}
            onlyView={true}
            className="h-[120px] w-[120px] overflow-hidden rounded-[50%] mx-[auto] flex justify-center items-center"
            id={`avatarCanvas-${""}`}
            layerCode={selectedAvatar ? selectedAvatar : user.avatar}
            width={120}
            height={120}
            setSelectedAvatar={setSelectedAvatar}
          />
          <h4 className="text-[20px] text-[#fff] mb-[15px]">{user?.username}</h4>

          <div className="topUpButton bg-[#00e6f4] min-w-[120px] inline-flex rounded-[40px] items-center justify-center px-4 py-2">
            <span className="d-flex mt-[1px] text-[#000]">
            <img
                  src={balanceIcon}
                  alt="numberIMg"
                  title="numberIMg"
                  className="w-[20px] h-[18px] mt-[2px] mr-[5px] aspect-square"
                />
              {user?.balance}
            </span>
          </div>
          <div className="flex text-white justify-between w-full mt-4 mb-3 mx-0 px-[50px]">
            <span
              className={`${
                activeTab === "account" ? "text-[#00e6f4]" : ""
              } cursor-pointer`}
              onClick={() => setActiveTab("account")}
            >
              {" "}
              Account Settings{" "}
            </span>
            <span
              className={`${
                activeTab === "played" ? "text-[#00e6f4]" : ""
              } cursor-pointer`}
              onClick={() => setActiveTab("played")}
            >
              {" "}
              Played Games{" "}
            </span>
          </div>
          {activeTab && activeTab === "account" ? (
            <ProfileInfoForm
              setSelectedAvatar={setSelectedAvatar}
              selectedAvatar={selectedAvatar}
            />
          ) : (
            <PlayedGamesList />
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(Settings);
